import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { useSite } from "@/lib/site";
import Seo from "@/components/Seo";
import Breadcrumb from "@/components/Breadcrumb";
import { Reveal } from "@/components/Reveal";
import { IdentityLabel } from "@/components/ui-bits";

export default function Services() {
  const { data: services = [] } = useQuery({ queryKey: ["services"], queryFn: async () => (await api.get("/services")).data });
  const { pageContent } = useSite();
  const content = pageContent.services || {};
  return (
    <div data-testid="services-page">
      <Seo title="Layanan Digital Marketing Medan | Digitalis" description="Layanan digital marketing Digitalis di Medan: social media marketing, micro influencer, optimasi Google Maps, social media growth, dan SEO." canonicalPath="/services" />
      <section className="mx-auto max-w-[1400px] px-5 md:px-10 pt-10 md:pt-14 pb-10 md:pb-14">
        <Breadcrumb items={[{ label: "Home", to: "/" }, { label: "Services" }]} />
        <div className="mt-7 grid gap-5 lg:grid-cols-[1fr_0.75fr] lg:items-end">
          <div><IdentityLabel>{content.eyebrow || "Pilih Sesuai Tujuan"}</IdentityLabel><h1 className="font-display font-extrabold tracking-tightest leading-tight text-[2.35rem] sm:text-5xl md:text-6xl">{content.title || "Layanan untuk Membuat Brand Lebih Terlihat"}</h1></div>
          <p className="text-muted-foreground text-base md:text-lg lg:pb-1">{content.description || "Kenali layanan, hasil yang didapat, dan contoh karya hanya dalam sekali lihat."}</p>
        </div>
      </section>
      {content.show_cards !== false && <section className="border-t border-border py-10 md:py-16">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <div className="grid grid-cols-2 gap-3 sm:gap-5 lg:grid-cols-3">
          {services.map((s, i) => (
            <Reveal key={s.id} className="min-w-0">
              <Link to={`/services/${s.slug}`} className="group flex h-full min-w-0 flex-col overflow-hidden rounded-2xl border border-border bg-card transition-colors hover:border-primary/50 sm:rounded-3xl" data-testid={`service-row-${s.slug}`}>
                <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
                  <img src={s.thumbnail || s.hero_image} alt={s.name} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]" />
                  <span className="absolute left-2.5 top-2.5 rounded-full bg-background/95 px-2.5 py-1 text-[9px] font-bold sm:left-4 sm:top-4 sm:text-[10px]">{String(i + 1).padStart(2, "0")}</span>
                  {s.flagship && <span className="absolute right-2.5 top-2.5 rounded-full bg-primary px-2.5 py-1 text-[8px] font-bold text-primary-foreground sm:right-4 sm:top-4 sm:text-[10px]">Utama</span>}
                </div>
                <div className="flex flex-1 flex-col p-3.5 sm:p-5 md:p-6">
                  <div className="flex items-start justify-between gap-2"><h2 className="break-words font-display text-base font-bold leading-tight sm:text-xl md:text-2xl">{s.name}</h2><ArrowUpRight className="h-4 w-4 shrink-0 text-primary sm:h-5 sm:w-5" /></div>
                  <p className="mt-2 line-clamp-3 text-[11px] leading-relaxed text-muted-foreground sm:text-sm">{s.short_description}</p>
                  <div className="mt-4 hidden flex-wrap gap-1.5 sm:flex">{(s.benefits || []).slice(0, 3).map((benefit) => <span key={benefit} className="rounded-full border border-border px-2.5 py-1 text-[10px] text-muted-foreground">{benefit}</span>)}</div>
                  <span className="mt-auto pt-4 text-[10px] font-semibold text-primary sm:text-xs">Lihat hasil & contoh kerja →</span>
                </div>
              </Link>
            </Reveal>
          ))}
          </div>
        </div>
      </section>}
    </div>
  );
}
